module.exports = __webpack_public_path__ + "media/images/partners/depkult2025-e7a9cb97f5a48ee81ef1cf33b1fa61f3.svg";